import React from 'react'
import { GridCell, GridFilterCell } from '@progress/kendo-react-grid'
import { Select } from 'components/select'

const lookupCell = () => {
  return class LookupCell extends GridCell {
    render () {
      const item = this.props.dataItem[this.props.field] || { name: `field: ${this.props.field}, item: ${this.props.dataItem}`}
      return (
        <td>{item.name}</td>
      )
    }
  }
}

// createLookupFilterCell not working
const createLookupFilterCell = ({ items }) => {
  return class LookupFilterCell extends GridFilterCell {
    onValueChange = (value) => {
      this.props.onChange({
        value: value === -1 ? null : value,
        operator: value !== -1 ? 'eq' : ''
      })
    }
    
    render () {
      const { value } = this.props
      return (
        <Select
          data={items}
          nullable
          menuPosition='fixed'
          value={value}
          onChange={this.onValueChange}
        />
      )
    }
  }
}
export {
  lookupCell,
  createLookupFilterCell
}